// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.enjin",
    name: "Enjin Wallet",
    homepage: "https://enjin.io/products/wallet",
    image_id: "add9626b-a5fa-4c12-178c-e5584e6dcd00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/enjin-nft-crypto-wallet/id1349078375",
        android: "https://play.google.com/store/apps/details?id=com.enjin.mobile.wallet",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "enjinwallet://",
        universal: "https://deeplink.wallet.enjin.io/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map